import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import { getQuery } from 'bv-utils'
import type { IGameResearchInfo, INonGameResearchInfo } from '@/services/infoResearch/infoResearch'
import { listService } from '@/services/infoResearch/infoResearch'
import type { InfoResearchType } from '@/pages/InfoResearch'
import { putSave } from '@/models/utils'

type InfoResearchInfo = {

} & IGameResearchInfo & INonGameResearchInfo

export type ResearchModelState = ListModelState<InfoResearchInfo> & { id: number, type?: InfoResearchType};
export type ResearchListModel = ListModel<ResearchModelState, 'research'>;

const listState: ResearchModelState = { ...defaultListState, id: 0, type: '' }

const ResearchModel: ResearchListModel = {
  namespace: 'research',
  state: listState,
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state.research.id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(listService[params], getQuery())
      const currentId: number = yield select((state: any) => state.research.id)
      if (currentId === requestId) {
        yield put(putSave({  error,  data: data ?? defaultListData, loading: false }))
      }
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default ResearchModel
